import { createContext, type ReactElement, type ReactNode, useContext } from 'react';

import type { SessionRefresher } from './session';

/**
 * 액세스 토큰 재발급기를 화면에 내려 준다.
 *
 * 화면이 `auth.refresh` 를 직접 부르면 안 되기 때문에 있는 통로다 — 리프레시 토큰은
 * 쓸 때마다 회전하므로, 앱 부팅과 화면이 각자 부르면 서버가 그것을 탈취로 보고
 * 세션을 통째로 끊는다. 이 재발급기 하나만 쓰면 동시 호출이 한 번으로 합쳐진다.
 */
const SessionRefreshContext = createContext<SessionRefresher | null>(null);

export function SessionRefreshProvider({
  refresh,
  children,
}: {
  refresh: SessionRefresher;
  children: ReactNode;
}): ReactElement {
  return (
    <SessionRefreshContext.Provider value={refresh}>{children}</SessionRefreshContext.Provider>
  );
}

export function useSessionRefresh(): SessionRefresher {
  const refresh = useContext(SessionRefreshContext);
  if (refresh === null) {
    throw new Error('useSessionRefresh 는 SessionRefreshProvider 안에서만 쓸 수 있습니다');
  }
  return refresh;
}
